import React, { useContext, useEffect, useRef, useState } from 'react'
import './Vikrireport.css'
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import { Document, Page, Text, View, StyleSheet, PDFViewer, Image } from '@react-pdf/renderer';
import { Font } from '@react-pdf/renderer';
import LatoItalicFont from "../../Fonts/Baloo2-VariableFont_wght.ttf";
import Logo from "../../imgs/dairylogo.png";
import back from "../../imgs/backexam.png";
import { useNavigate } from 'react-router-dom';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import { YoutubeSearchedForOutlined } from '@material-ui/icons';
import { useTranslation } from "react-i18next";
import NotoSansKannada from "../../Fonts/NotoSansKannada.ttf";

const Vikrireport = (props) => {
  const { t, i18n } = useTranslation();

  // ✅ Kannada font for web (loads ttf dynamically)
  const lang = i18n?.language || localStorage.getItem("i18nextLng") || "mr";
  const isKn = (lang || "").toLowerCase().startsWith("kn");
  const [fontReady, setFontReady] = useState(false);

  useEffect(() => {
    let cancelled = false;

    async function loadKnFont() {
      try {
        if (!isKn) {
          if (!cancelled) setFontReady(false);
          return;
        }
        if (document?.fonts?.check?.('12px KannadaWeb')) {
          if (!cancelled) setFontReady(true);
          return;
        }
        const ff = new FontFace('KannadaWeb', `url(${NotoSansKannada})`);
        await ff.load();
        document.fonts.add(ff);
        if (!cancelled) setFontReady(true);
      } catch (e) {
        if (!cancelled) setFontReady(false);
      }
    }

    loadKnFont();
    return () => {
      cancelled = true;
    };
  }, [isKn]);

  const webFontStyle = isKn ? { fontFamily: 'KannadaWeb' } : {};

  const [input, setInput] = useState({ date1: new Date().toISOString().substr(0, 10), date2: new Date().toISOString().substr(0, 10), rno: '', grtype: "" });
  const inputRefs = useRef([]);
  const [DataSource, setDataSource] = useState([]);
  const [DataSource3, setDataSource3] = useState([]);
  const [DataSourceratibsabh, setDataSourceratibsabh] = useState([]);
  const [DataSourcesatesabh, setDataSourceStatementsabh] = useState([]);
  const [PreviousAmt, setPreviousAmt] = useState();
  const [tableFilter, setTableFilter] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [print, setprint] = useState(false);
  const cellRefs = useRef([]);
  const [value, setValue] = useState('');
  const notify = (msg) => toast(msg);
  const notifyerror = (msg) => toast.error(msg);
  const [customerData, setCustomerData] = useState([]);
  const [rtype, setRtype] = useState("sanghvikri");
  const [ratibtype, setRatibtype] = useState("ratibvikrisabh");
  const navigate = useNavigate();
  const refprint = useRef(null);
  const refprintclose = useRef(null);
  const [wait, setWait] = useState(false);

  const handlertype = (rtypetemp) => {
    if (rtypetemp === "sanghvikri") {
      setDataSource([]);
      setDataSource3([]);
      setDataSourceratibsabh([]);
      setDataSourceStatementsabh([]);
      setRtype("sanghvikri");
    }
    else if (rtypetemp === "ratibvikri") {
      setDataSource([]);
      setDataSource3([]);
      setDataSourceratibsabh([]);
      setDataSourceStatementsabh([]);

      setRtype("ratibvikri");
    }
    else if (rtypetemp === "kirkol") {
      setDataSource([]);
      setDataSource3([]);
      setDataSourceratibsabh([]);
      setDataSourceStatementsabh([]);

      setRtype("kirkol");
    }
    else if (rtypetemp === "ratiball") {
      setDataSource([]);
      setDataSource3([]);
      setDataSourceratibsabh([]);
      setDataSourceStatementsabh([]);

      setRtype("ratiball");
    }
    else if (rtypetemp === "statement") {
      setDataSource([]);
      setDataSource3([]);
      setDataSourceratibsabh([]);
      setDataSourceStatementsabh([]);

      setRtype("statement");
    }
  }

  const handleRatibtype = (rtypetemp) => {
    if (rtypetemp === "ratibvikrisabh") {
      setDataSource([]);
      setDataSource3([]);
      setDataSourceratibsabh([]);
      setDataSourceStatementsabh([]);

      setRatibtype("ratibvikrisabh");
    }
    else if (rtypetemp === "ratibvikrigr") {
      setDataSource([]);
      setDataSource3([]);
      setDataSourceratibsabh([]);
      setDataSourceStatementsabh([]);

      setRatibtype("ratibvikrigr");
    }
  }

  const handletypeclose = () => {
    refprintclose.current.click();
  }

  const handletype = () => {
    refprint.current.click();
  }

  useEffect(() => {
    setDataSource([]);
  }, [rtype])

  function handleEnterKey(event, currentIndex) {

    if (event.keyCode === 8) {
      if (event.target.name === "time") {
        setInput((prevInputSettings) => ({
          ...prevInputSettings,
          time: '',
        }));
      }
      else if (event.target.name === "type") {
        setInput((prevInputSettings) => ({
          ...prevInputSettings,
          type: '',
        }));
      }
    }

    if (event.key === 'Enter' || event.key === "Tab") {
      event.preventDefault();
      let nextIndex = null;
      if (currentIndex === 2) {
        if (input.name !== "") {
          nextIndex = currentIndex + 1;
        }
        else {
          nextIndex = currentIndex;
        }
      }
      else {
        nextIndex = currentIndex + 1;
      }
      if (inputRefs.current[nextIndex]) {
        inputRefs.current[nextIndex].focus();
      }
    }
  }

  const filteData = (e) => {
    const searchValue = e.target.value.trim();
    if (searchValue !== "") {
      setValue(searchValue);

      if (rtype === "ratiball") {
        const filtertable = DataSource3.filter(o =>
          String(o.rno) === searchValue // Check for exact match with kno
        );
        setTableFilter([...filtertable]);
      }
      else {
        const filtertable = DataSource.filter(o =>
          String(rtype === "sanghvikri" ? o.sno : o.kno) === searchValue // Check for exact match with kno
        );
        setTableFilter([...filtertable]);
      }
    } else {
      setValue(searchValue);
      setTableFilter([...DataSource]);
    }
  };

  const showprint = () => {
    if (rtype === "sanghvikri" || rtype === "kirkol") {
      if (DataSource && DataSource.length > 0) {
        localStorage.setItem("date1print", input.date1);
        localStorage.setItem("date2print", input.date2);
        localStorage.setItem("rtype", rtype);
        localStorage.setItem("ratibtype", ratibtype);
        localStorage.setItem("grtype", input.grtype);
        localStorage.setItem("rno", input.rno);
        const url = "/vikrireportprint";
        window.open(url, '_blank');  //_blank
      }
      else {
        notifyerror(t("vikrireport.errors.noRatibForPeriod"));
      }
    }
    else if (rtype === "ratibvikri" && (ratibtype === "ratibvikrisabh" || ratibtype === "ratibvikrigr")) {
      if (DataSourceratibsabh && DataSourceratibsabh.length > 0) {
        localStorage.setItem("date1print", input.date1);
        localStorage.setItem("date2print", input.date2);
        localStorage.setItem("rtype", rtype);
        localStorage.setItem("ratibtype", ratibtype);
        localStorage.setItem("grtype", input.grtype);
        localStorage.setItem("rno", input.rno);
        const url = "/vikrireportprint";
        window.open(url, '_blank');  //_blank
      }
      else {
        notifyerror(t("vikrireport.errors.noRatibForPeriod"));
      }
    }
    else if (rtype === "statement" && (ratibtype === "ratibvikrisabh" || ratibtype === "ratibvikrigr")) {
      if (DataSourcesatesabh && DataSourcesatesabh.length > 0) {
        localStorage.setItem("date1print", input.date1);
        localStorage.setItem("date2print", input.date2);
        localStorage.setItem("rtype", rtype);
        localStorage.setItem("ratibtype", ratibtype);
        localStorage.setItem("grtype", input.grtype);
        localStorage.setItem("rno", input.rno);
        const url = "/vikrireportprint";
        window.open(url, '_blank');  //_blank
      }
      else {
        notifyerror(t("vikrireport.errors.noRatibForPeriod"));
      }
    }
    else {
      if (rtype === "ratiball" && (ratibtype === "ratibvikrisabh" || ratibtype === "ratibvikrigr")) {
        if (DataSource3 && DataSource3.length > 0) {
          localStorage.setItem("date1print", input.date1);
          localStorage.setItem("date2print", input.date2);
          localStorage.setItem("rtype", rtype);
          localStorage.setItem("ratibtype", ratibtype);
          localStorage.setItem("grtype", input.grtype);
          localStorage.setItem("rno", input.rno);
          const url = "/vikrireportprint";
          window.open(url, '_blank');  //_blank
        }
        else {
          notifyerror(t("vikrireport.errors.noRatibForPeriod"));
        }
      }
    }
  }

  const handleChange = async (event) => {
    const name = event.target.name;
    let valuecurrent = "";
    valuecurrent = event.target.value;
    setInput(value => ({ ...value, [name]: valuecurrent }));

    if (name === 'date2') {
      const date1 = new Date(input.date1);
      const date2 = new Date(valuecurrent);
      const differenceInDays = (date2 - date1) / (1000 * 60 * 60 * 24);

      if (differenceInDays <= 30) {
        setInput((prevInput) => ({ ...prevInput, [name]: valuecurrent }));
      } else {
        notifyerror(t("vikrireport.errors.reportLimitOneMonth"));
        setInput((prevInput) => ({ ...prevInput, [name]: new Date().toISOString().substr(0, 10) }));
      }
    }
  }

  const getsanghvikrireport = () => {
    var mainuser2 = jsEncode.encode("mamapr", 125);
    if (input.kno === "") {
      notifyerror(t("vikrireport.errors.enterMemberAccountNo"));
      setDataSource([]);
      return;
    }
    let rawData = {
      date1: input.date1,
      date2: input.date2,
      mainuser: localStorage.getItem("contact"),
      mainuser2: mainuser2,
    }
    rawData = JSON.stringify(rawData)
    let formData = new FormData()
    formData.append('data', rawData)
    axios.post('https://excellentdairy.com/dairy/php/cust/getsanghvikrireport.php', formData, {
      'Content-Type': 'multipart/form-data',

    }).then(function sample(response) {

      if (response.data && response.data.length > 0) {
        setDataSource(response.data);
      }
      else {
        notifyerror(t("sanklanreport.errors.noData"));
        setDataSource([]);
      }
    }).catch(err => {
      console.log(err);
    });
  }

  const choicereport = () => {
    refprint.current.click();
  }

  const getratibvikrisabh = () => {
    setWait(true);
    var mainuser2 = jsEncode.encode("mamapr", 125);

    if (input.rno === "") {
      notifyerror(t("vikrireport.errors.enterMemberAccountNo"));
      setDataSource([]);
      setWait(false);
      return;
    }
    let phplanding = "";
    if (ratibtype === "ratibvikrisabh") {
      phplanding = "getratibvikrisabh2.php";
    }
    else if (ratibtype === "ratibvikrigr") {
      phplanding = "getratibvikrigr.php";
    }

    let rawData = {
      date1: input.date1,
      date2: input.date2,
      rno: input.rno,
      mainuser: localStorage.getItem("contact"),
      mainuser2: mainuser2,
    }
    rawData = JSON.stringify(rawData)
    let formData = new FormData()
    formData.append('data', rawData)
    axios.post(`https://excellentdairy.com/dairy/php/cust/${phplanding}`, formData, {
      'Content-Type': 'multipart/form-data',

    }).then(function sample(response) {

      if (response.data && response.data.length > 0) {
        setDataSourceratibsabh(response.data);
        refprintclose.current.click();
        setWait(false);
      }
      else {
        notifyerror(t("sanklanreport.errors.noData"));
        setDataSourceratibsabh([]);
        refprintclose.current.click();
        setWait(false);
      }
    }).catch(err => {
      console.log(err);
      refprintclose.current.click();
      setWait(false);
    });
  }

  const getratibstatementsabh = () => {
    var mainuser2 = jsEncode.encode("mamapr", 125);
    if (input.kno === "") {
      notifyerror(t("vikrireport.errors.enterMemberAccountNo"));
      setDataSource([]);
      return;
    }
    let phplanding = "";
    if (ratibtype === "ratibvikrisabh") {
      phplanding = "getratibsabhstatement.php";
    }
    else if (ratibtype === "ratibvikrigr") {
      phplanding = "getratibgrstatement.php";
    }

    let rawData = {
      date1: input.date1,
      date2: input.date2,
      kno: input.rno,
      mainuser: localStorage.getItem("contact"),
      mainuser2: mainuser2,
    }
    rawData = JSON.stringify(rawData)
    let formData = new FormData()
    formData.append('data', rawData)
    axios.post(`https://excellentdairy.com/dairy/php/cust/${phplanding}`, formData, {
      'Content-Type': 'multipart/form-data',

    }).then(function sample(response) {
      if (response.data && response.data.length > 0) {
        setDataSourceStatementsabh(response.data);
        refprintclose.current.click();
      }
      else {
        notifyerror(t("sanklanreport.errors.noData"));
        setDataSourceStatementsabh([]);
        refprintclose.current.click();
      }
    }).catch(err => {
      console.log(err);
      refprintclose.current.click();
    });
  }

  const getratibyenebakiyadi = () => {
    var mainuser2 = jsEncode.encode("mamapr", 125);
    let phplanding = "";
    if (ratibtype === "ratibvikrisabh") {
      phplanding = "getratibyenebakiyadisabh.php";
    }
    else if (ratibtype === "ratibvikrigr") {
      phplanding = "getratibyenebakiyadi.php";
    }

    let rawData = {
      date1: input.date1,
      date2: input.date2,
      rno: input.rno,
      grtype: input.grtype,
      mainuser: localStorage.getItem("contact"),
      mainuser2: mainuser2,
    }
    rawData = JSON.stringify(rawData)
    let formData = new FormData()
    formData.append('data', rawData)
    axios.post(`https://excellentdairy.com/dairy/php/cust/${phplanding}`, formData, {
      'Content-Type': 'multipart/form-data',

    }).then(function sample(response) {
      if (response.data && response.data.length > 0) {
        setDataSource3(response.data);
        refprintclose.current.click();
      }
      else {
        notifyerror(t("sanklanreport.errors.noData"));
        setDataSource3([]);
        refprintclose.current.click();
      }
    }).catch(err => {
      console.log(err);
    });
  }

  const getkirkolreport = () => {
    var mainuser2 = jsEncode.encode("mamapr", 125);
    if (input.kno === "") {
      notifyerror(t("vikrireport.errors.enterMemberAccountNo"));
      setDataSource([]);
      refprintclose.current.click();
      return;
    }

    let rawData = {
      date1: input.date1,
      date2: input.date2,
      rno: input.rno,
      grtype: input.grtype,
      mainuser: localStorage.getItem("contact"),
      mainuser2: mainuser2,

    }
    rawData = JSON.stringify(rawData)
    let formData = new FormData()
    formData.append('data', rawData)
    axios.post(`https://excellentdairy.com/dairy/php/cust/getkirkolvikrireport.php`, formData, {
      'Content-Type': 'multipart/form-data',

    }).then(function sample(response) {

      if (response.data && response.data.length > 0) {
        setPreviousAmt(response.data[0].prevamt);
        setDataSource(response.data);
      }
      else {
        notifyerror(t("sanklanreport.errors.noData"));
        setDataSource([]);
      }
    }).catch(err => {
      console.log(err);
    });
  }

  function formatDate(inputDate) {
    const parts = inputDate.split('-');
    if (parts.length !== 3) {
      return '';
    }

    const months = [
      'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
      'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
    ];

    const year = parts[0];
    const month = parseInt(parts[1]) - 1;
    const day = parts[2];

    return `${day}-${months[month]}-${year}`;
  }

  var jsEncode = {
    encode: function (s, k) {
      var enc = "";
      var str = s.toString();
      for (var i = 0; i < str.length; i++) {
        var a = str.charCodeAt(i);
        var b = a ^ k;
        enc = enc + String.fromCharCode(b);
      }
      return enc;
    }
  };

  return (
    <div style={webFontStyle}>
      <button
        type="button"
        className="btn btn-primary"
        data-bs-toggle="modal"
        hidden="{true}"
        ref={refprint}
        data-bs-target="#reportlayout"
      >
      </button>

      <div className="modal fade" id="reportlayout" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel"></h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" ref={refprintclose} aria-label="Close">
              </button>
            </div>
            <div className="modal-body">
              <h5 className="modal-title" id="exampleModalLabel">{t("vikrireport.modal.title")}</h5>
              <span className='note'>{t("vikrireport.modal.note")}</span>
              <div className="radiotheme">

                <div className="form-check">
                  <input onClick={e => handleRatibtype("ratibvikrisabh")} defaultChecked className="form-check-input" type="radio" name="radio2" id="radio2" value="option1" />
                  <label clas sName="form-check-label radiolabel" htmlFor="radio2">
                    {t("vikrireport.modal.member")}
                  </label>
                </div>
                <div className="form-check">
                  <input onClick={e => handleRatibtype("ratibvikrigr")} className="form-check-input" type="radio" name="radio2" id="radio2" value="option1" />
                  <label className="form-check-label radiolabel" htmlFor="radio2">
                    {t("vikrireport.modal.customer")}
                  </label>
                </div>

              </div>

            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={handletypeclose}>{t("common.close")}</button>
              {
                wait ?
                  <button type="button" className="btn btn-danger">{t("common.loading")}</button>
                  :
                  <button type="button" className="btn btn-danger" onClick={rtype === "ratibvikri" ? (ratibtype === "ratibvikrisabh" || ratibtype === "ratibvikrigr" ? getratibvikrisabh : undefined) : rtype === "statement" ? (ratibtype === "ratibvikrisabh" || ratibtype === "ratibvikrigr" ? getratibstatementsabh : undefined) : rtype === "ratiball" ? (ratibtype === "ratibvikrisabh" || ratibtype === "ratibvikrigr" ? getratibyenebakiyadi : undefined) : undefined}>{t("vikrireport.buttons.ok")}</button>
              }
            </div>
          </div>
        </div>
      </div>

      <div className="sanklanmain">
        <div className="firstrowsank">
          <img onClick={props.visibility} className='back' src={back} alt="" />
          <div className="colmain">
            <div className="firstrow2">
              <div className="rowbill">

                {
                  rtype !== "ratiball" ?
                    <>
                      <div className="mb-2">
                        <span className='subheadsank'>{t("common.date")}</span>
                        <input onKeyDown={e => handleEnterKey(e, 0)} ref={ref => (inputRefs.current[0] = ref)} type="date" className="form-control" autoComplete='off' id="date1" name="date1" value={input.date1} onChange={handleChange} ></input>
                      </div>

                      <span className='subheadbill'>{t("common.to")}</span>

                      <div className="mb-2">
                        <span className='subheadsank'>{t("common.date")}</span>
                        <input onKeyDown={e => handleEnterKey(e, 1)} ref={ref => (inputRefs.current[1] = ref)} type="date" className="form-control" autoComplete='off' id="date2" name="date2" value={input.date2} onChange={handleChange} ></input>
                      </div>
                    </>
                    : ''
                }

                {
                  rtype === "statement" || rtype === "ratibvikri" ?

                    <>
                      <div className="mb-2">
                        <span className='subheadsank'>{t("common.table.account_no")}</span>
                        <input onKeyDown={e => handleEnterKey(e, 1)} ref={ref => (inputRefs.current[1] = ref)} type="number" className="form-control" autoComplete='off' id="rno" name="rno" value={input.rno} onChange={handleChange} ></input>
                      </div>
                    </>
                    :
                    ''
                }
                <div className="mb-2">
                  <button onClick={rtype === "sanghvikri" ? getsanghvikrireport : rtype === "kirkol" ? getkirkolreport : rtype === "ratibvikri" || rtype === "statement" ? choicereport : rtype === "ratiball" ? choicereport : getratibyenebakiyadi} ref={ref => (inputRefs.current[4] = ref)} type="submit" id='show' className="btn btn-primary mx-1 sanksmall">{t("vikrireport.buttons.viewReport")}</button>
                  <button onClick={showprint} ref={ref => (inputRefs.current[4] = ref)} type="submit" id='print' className="btn btn-primary mx-1 sanksmall">{t("common.print")}</button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="firstrow2">
          <div class="table-containerbill">
            <div className="buttonsreportsank">
              <input type="text" className="form-control searchsank mx-3" id="searchsank" name="searchsank" placeholder={t("sanklanreport.placeholders.searchAccountNo")} value={value} onChange={filteData} autoComplete='off' />

              <div className="radio">
                <div className="form-check">

                </div>
                <div className="form-check">

                </div>
              </div>
              <div className="radio">

                <div className="form-check">
                  <input onClick={() => { handlertype("sanghvikri") }} defaultChecked className="form-check-input" type="radio" name="exampleRadios" id="radio2" value="option2" />
                  <label className="form-check-label" htmlFor="radio2">
                    {t("vikrireport.radios.unionSaleReport")}
                  </label>
                </div>
                <div className="form-check">
                  <input onClick={() => { handlertype("ratibvikri") }} className="form-check-input" type="radio" name="exampleRadios" id="radio2" value="option2" />
                  <label className="form-check-label" htmlFor="radio2">
                    {t("vikrireport.radios.ratibSaleReport")}
                  </label>
                </div>
              </div>
              <div className="radio">
                <div className="form-check">
                  <input onClick={() => { handlertype("statement") }} className="form-check-input" type="radio" name="exampleRadios" id="radio1" value="option1" />
                  <label className="form-check-label" htmlFor="radio1">
                    {t("vikrireport.radios.ratibLedger")}
                  </label>
                </div>
                <div className="form-check">
                  <input onClick={() => { handlertype("ratiball") }} className="form-check-input" type="radio" name="exampleRadios" id="radio1" value="option1" />
                  <label className="form-check-label" htmlFor="radio1">
                    {t("vikrireport.radios.ratibReceivableList")}
                  </label>
                </div>
              </div>
            </div>

            {
              rtype === "sanghvikri" ?
                <>
                  <table id="myTablebillyenebaki" className="table table-bordered">
                    <thead>
                      <tr>
                        <th className='thsmallyenebaki' scope="col">{t("common.table.date")}</th>
                        <th className='thsmallyenebaki' scope="col">{t("sanklanreport.tableAll.account")}</th>
                        <th className='thsmallvikrimedium2' scope="col">{t("vikrireport.table.unionName")}</th>
                        <th className='thsmallyenebaki' scope="col">{t("common.table.time")}</th>
                        <th className='thsmallyenebaki' scope="col">{t("common.table.type")}</th>
                        <th className='thsmallyenebaki' scope="col">{t("common.table.liter")}</th>
                        <th className='thsmallyenebaki' scope="col">{t("common.table.fat")}</th>
                        <th className='thsmallyenebaki' scope="col">{t("common.table.snf")}</th>
                        <th className='thsmallyenebaki' scope="col">{t("vikrireport.table.commission")}</th>
                        <th className='thsmallyenebaki' scope="col">{t("common.table.rate")}</th>
                        <th className='thsmallyenebaki' scope="col">{t("common.table.amount")}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {value.length > 0 ? tableFilter.map((user, index) =>
                        <tr key={index}>
                          <td className='thsmallyenebaki'>{formatDate(user.date)}</td>
                          <td className='thsmallyenebaki'>{user.sno}</td>
                          <td className='thsmallvikrimedium2'>{user.sname}</td>
                          <td className='thsmallyenebaki'>{user.time && user.time !== "" ? user.time : "-"}</td>
                          <td className='thsmallyenebaki'>{user.type && user.type !== "" ? user.type : "-"}</td>
                          <td className='thsmallyenebaki'>{user.liter && user.liter !== "" ? parseFloat(user.liter) : 0}</td>
                          <td className='thsmallyenebaki'>{user.fat && user.fat !== "" ? parseFloat(user.fat) : 0}</td>
                          <td className='thsmallyenebaki'>{user.snf && user.snf !== "" ? parseFloat(user.snf) : 0}</td>
                          <td className='thsmallyenebaki'>{user.comm && user.comm !== "" ? parseFloat(user.comm) : 0}</td>
                          <td className='thsmallyenebaki'>{user.rate && user.rate !== "" ? parseFloat(user.rate) : 0}</td>
                          <td className='thsmallyenebaki'>{user.amt && user.amt !== "" ? parseFloat(user.amt) : 0}</td>
                        </tr>
                      )
                        :
                        DataSource && DataSource.map((user, index) =>
                          <tr key={index}>
                            <td className='thsmallyenebaki'>{formatDate(user.date)}</td>
                            <td className='thsmallyenebaki'>{user.sno}</td>
                            <td className='thsmallvikrimedium2'>{user.sname}</td>
                            <td className='thsmallyenebaki'>{user.time && user.time !== "" ? user.time : "-"}</td>
                            <td className='thsmallyenebaki'>{user.type && user.type !== "" ? user.type : "-"}</td>
                            <td className='thsmallyenebaki'>{user.liter && user.liter !== "" ? parseFloat(user.liter) : 0}</td>
                            <td className='thsmallyenebaki'>{user.fat && user.fat !== "" ? parseFloat(user.fat) : 0}</td>
                            <td className='thsmallyenebaki'>{user.snf && user.snf !== "" ? parseFloat(user.snf) : 0}</td>
                            <td className='thsmallyenebaki'>{user.comm && user.comm !== "" ? parseFloat(user.comm) : 0}</td>
                            <td className='thsmallyenebaki'>{user.rate && user.rate !== "" ? parseFloat(user.rate) : 0}</td>
                            <td className='thsmallyenebaki'>{user.amt && user.amt !== "" ? parseFloat(user.amt) : 0}</td>
                          </tr>
                        )
                      }
                    </tbody>
                    <tr style={{ backgroundColor: 'lightgray', fontWeight: 'bold' }}>
                      <td className='thsmallcust'>{t("common.total")}</td>
                      <td className='thsmallcustlarge'>-</td>
                      <td className='thsmallcustlarge'>-</td>
                      <td className='thsmallcust'>-</td>
                      <td className='thsmallcust'>-</td>
                      <td className='thsmallcust'>
                        {value.length > 0
                          ? tableFilter.reduce((total, user) => total + parseFloat(user.liter), 0).toFixed(2)
                          : DataSource.reduce((total, user) => total + parseFloat(user.liter), 0).toFixed(2)}
                      </td>
                      <td className='thsmallcust'>-</td>
                      <td className='thsmallcust'>-</td>
                      <td className='thsmallcust'>
                        {value.length > 0
                          ? tableFilter.reduce((total, user) => total + parseFloat(user.comm), 0).toFixed(2)
                          : DataSource.reduce((total, user) => total + parseFloat(user.comm), 0).toFixed(2)}
                      </td>
                      <td className='thsmallcust'>-</td>
                      <td className='thsmallcust'>
                        {value.length > 0
                          ? tableFilter.reduce((total, user) => total + parseFloat(user.amt), 0).toFixed(2)
                          : DataSource.reduce((total, user) => total + parseFloat(user.amt), 0).toFixed(2)}
                      </td>
                    </tr>
                  </table>
                </>
                : rtype === "ratibvikri" && ratibtype === "ratibvikrisabh" ?
                  <table id="myTablebillyenebaki" className="table table-bordered">
                    <thead>
                      <tr>
                        <th className='thsmallvikri' scope="col">{t("common.table.date")}</th>
                        <th className='thsmallvikri' scope="col">{t("common.table.time")}</th>
                        <th className='thsmallvikri' scope="col">{t("sanklanreport.tableAll.account")}</th>
                        <th className='thsmallvikrimedium2' scope="col">{t("common.table.name")}</th>
                        <th className='thsmallvikri' scope="col">{t("common.table.liter")}</th>
                        <th className='thsmallvikri' scope="col">{t("common.table.rate")}</th>
                        <th className='thsmallvikri' scope="col">{t("common.table.amount")}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        DataSourceratibsabh && DataSourceratibsabh.map((user, index) =>
                          <tr key={index}  >
                            <td className='thsmallvikri'>{user.date && user.date !== "" ? user.date : "-"}</td>
                            <td className='thsmallvikri'>{user.time && user.time !== "" ? user.time : "-"}</td>
                            <td className='thsmallvikri'>{user.rno && user.rno !== "" ? user.rno : "-"}</td>
                            <td className='thsmallvikrimedium2'>{user.cname && user.cname !== "" ? (user.cname) : 0}</td>
                            <td className='thsmallvikri'>{user.liter && user.liter !== "" ? parseFloat(user.liter).toFixed(2) : 0}</td>
                            <td className='thsmallvikri'>{user.rate && user.rate !== "" ? parseFloat(user.rate).toFixed(2) : "-"}</td>
                            <td className='thsmallvikri'>{user.amt && user.amt !== "" ? parseFloat(user.amt).toFixed(2) : "-"}</td>
                          </tr>
                        )
                      }
                    </tbody>
                    <tr style={{ backgroundColor: 'lightgray', fontWeight: 'bold' }}>
                      <td className='thsmallcust'>{t("common.total")}</td>
                      <td className='thsmallcust'>-</td>
                      <td className='thsmallcust'>-</td>
                      <td className='thsmallcust'>-</td>
                      <td className='thsmallcust'>
                        {DataSourceratibsabh.reduce((total, user) => total + parseFloat(user.liter), 0).toFixed(2)}
                      </td>
                      <td className='thsmallcust'>-</td>
                      <td className='thsmallcust'>
                        {DataSourceratibsabh.reduce((total, user) => total + parseFloat(user.amt), 0).toFixed(2)}
                      </td>
                    </tr>
                  </table>

                  : rtype === "ratibvikri" && ratibtype === "ratibvikrigr" ?
                    <table id="myTablebill" className="table table-bordered">
                      <thead>
                        <tr>
                          <th className='thsmall' scope="col">{t("common.table.date")}</th>
                          <th className='thsmall' scope="col">{t("sanklanreport.tableAll.account")}</th>
                          <th className='thsmall' scope="col">{t("common.table.name")}</th>
                          <th className='thsmall' scope="col">{t("common.table.liter")}</th>
                          <th className='thsmall' scope="col">{t("common.table.rate")}</th>
                          <th className='thsmall' scope="col">{t("common.table.amount")}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          DataSourceratibsabh && DataSourceratibsabh.map((user, index) =>
                            <tr key={index}  >
                              <td className='thsmallcust'>{user.date && user.date !== "" ? user.date : "-"}</td>
                              <td className='thsmallcust'>{user.rno && user.rno !== "" ? user.rno : "-"}</td>
                              <td className='thsmallcust'>{user.rname && user.rname !== "" ? (user.rname) : 0}</td>
                              <td className='thsmallcust'>{user.liter && user.liter !== "" ? parseFloat(user.liter).toFixed(2) : 0}</td>
                              <td className='thsmallcust'>{user.rate && user.rate !== "" ? parseFloat(user.rate).toFixed(2) : "-"}</td>
                              <td className='thsmallcust'>{user.amt && user.amt !== "" ? parseFloat(user.amt).toFixed(2) : "-"}</td>
                            </tr>
                          )
                        }
                      </tbody>
                      <tr style={{ backgroundColor: 'lightgray', fontWeight: 'bold' }}>
                        <td className='thsmallcust'>{t("common.total")}</td>
                        <td className='thsmallcustlarge'>-</td>
                        <td className='thsmallcustlarge'>-</td>
                        <td className='thsmallcust'>
                          {DataSourceratibsabh.reduce((total, user) => total + parseFloat(user.liter), 0).toFixed(2)}
                        </td>
                        <td className='thsmallcust'>-</td>
                        <td className='thsmallcust'>
                          {DataSourceratibsabh.reduce((total, user) => total + parseFloat(user.amt), 0).toFixed(2)}
                        </td>
                      </tr>
                    </table>

                    : rtype === "statement" && ratibtype === "ratibvikrisabh" ?
                      <>
                        <span className='custname'>
                          {DataSourcesatesabh && DataSourcesatesabh.length > 0
                            ? t("vikrireport.texts.memberName", { name: DataSourcesatesabh[0].cname })
                            : ''}
                        </span>
                        <table id="myTablebillyenebaki" className="table table-bordered">
                          <thead>
                            <tr>
                              <th className='thsmallvikri' scope="col">{t("common.table.date")}</th>
                              <th className='thsmallvikrimedium3' scope="col">{t("vikrireport.table.particular")}</th>
                              <th className='thsmallvikri' scope="col">{t("vikrireport.table.debit")}</th>
                              <th className='thsmallvikri' scope="col">{t("vikrireport.table.credit")}</th>
                              <th className='thsmallvikri' scope="col">{t("common.balance")}</th>
                            </tr>
                          </thead>
                          <tbody>
                            {
                              DataSourcesatesabh && DataSourcesatesabh.map((user, index) =>
                                <tr key={index}  >
                                  <td className='thsmallvikri'>{user.date && user.date !== "" ? user.date : "-"}</td>
                                  <td className='thsmallvikrimedium3'>{user.particular} <br /> <span className='smallremark'> {user.remark} </span>  </td>
                                  <td className='thsmallvikri'>{user.nave && user.nave !== "" ? (user.nave) : 0}</td>
                                  <td className='thsmallvikri'>{user.jma && user.jma !== "" ? parseFloat(user.jma).toFixed(2) : 0}</td>
                                  <td className='thsmallvikri'>{user.closing_balance && user.closing_balance !== "" ? parseFloat(user.closing_balance).toFixed(2) : "-"}</td>
                                </tr>
                              )
                            }
                          </tbody>
                        </table>
                      </>

                      : rtype === "statement" && ratibtype === "ratibvikrigr" ?
                        <>
                          <span className='custname'>
                            {DataSourcesatesabh && DataSourcesatesabh.length > 0
                              ? t("vikrireport.texts.ratibCustomerName", { name: DataSourcesatesabh[0].cname })
                              : ''}
                          </span>
                          <table id="myTablebillyenebaki" className="table table-bordered">
                            <thead>
                              <tr>
                                <th className='thsmallvikri' scope="col">{t("common.table.date")}</th>
                                <th className='thsmallvikrimedium3' scope="col">{t("vikrireport.table.particular")}</th>
                                <th className='thsmallvikri' scope="col">{t("vikrireport.table.debit")}</th>
                                <th className='thsmallvikri' scope="col">{t("vikrireport.table.credit")}</th>
                                <th className='thsmallvikri' scope="col">{t("common.balance")}</th>
                              </tr>
                            </thead>
                            <tbody>
                              {
                                DataSourcesatesabh && DataSourcesatesabh.map((user, index) =>
                                  <tr key={index}  >
                                    <td className='thsmallvikri'>{user.date && user.date !== "" ? user.date : "-"}</td>
                                    <td className='thsmallvikrimedium3'>{user.particular} <br /> <span className='smallremark'> {user.remark} </span>  </td>
                                    <td className='thsmallvikri'>{user.nave && user.nave !== "" ? (user.nave) : 0}</td>
                                    <td className='thsmallvikri'>{user.jma && user.jma !== "" ? parseFloat(user.jma).toFixed(2) : 0}</td>
                                    <td className='thsmallvikri'>{user.closing_balance && user.closing_balance !== "" ? parseFloat(user.closing_balance).toFixed(2) : "-"}</td>
                                  </tr>
                                )
                              }
                            </tbody>
                          </table>

                        </>
                        : rtype === "kirkol" ?
                          <>
                            <table id="myTablebill" className="table table-bordered">
                              <thead>
                                <tr>
                                  <th className='thsmall' scope="col">{t("common.table.date")}</th>
                                  <th className='thsmall' scope="col">{t("common.type")}</th>
                                  <th className='thsmall' scope="col">{t("vikrireport.table.accountNoShort")}</th>
                                  <th className='thsmall' scope="col">{t("common.type")}</th>
                                  <th className='thsmall' scope="col">{t("common.table.time")}</th>
                                  <th className='thsmall' scope="col">{t("common.type")}</th>
                                  <th className='thsmall' scope="col">{t("common.table.liter")}</th>
                                  <th className='thsmall' scope="col">{t("common.table.rate")}</th>
                                  <th className='thsmall' scope="col">{t("common.table.amount")}</th>

                                </tr>
                              </thead>
                              <tbody>
                                {value.length > 0 ? tableFilter.map((user, index) =>
                                  <tr key={index}>
                                    <td className='thsmallcust'>{formatDate(user.date)}</td>
                                    <td className='thsmallcustlarge'>{user.rno + ": " + user.rname}</td>
                                    <td className='thsmallcust'>{user.time && user.time !== "" ? user.time : "-"}</td>
                                    <td className='thsmallcust'>{user.type && user.type !== "" ? user.type : "-"}</td>
                                    <td className='thsmallcust'>{user.liter && user.liter !== "" ? parseFloat(user.liter) : 0}</td>
                                    <td className='thsmallcust'>{user.rate && user.rate !== "" ? parseFloat(user.rate) : 0}</td>
                                    <td className='thsmallcust'>{user.amt && user.amt !== "" ? parseFloat(user.amt) : 0}</td>
                                  </tr>
                                )
                                  :
                                  <>
                                    <tr key={0}>
                                      <td className='thsmallcustred'>{t("vikrireport.table.previousBalance")}</td>
                                      <td className='thsmallcustred'>{"-"}</td>
                                      <td className='thsmallcustred'>{"-"}</td>
                                      <td className='thsmallcustred'>{"-"}</td>
                                      <td className='thsmallcustred'>{"-"}</td>
                                      <td className='thsmallcustred'>{"-"}</td>
                                      <td className='thsmallcustred'>{"-"}</td>
                                      <td className='thsmallcustred'>{"-"}</td>
                                      <td className='thsmallcustred'>{PreviousAmt}</td>
                                    </tr>

                                    {
                                      DataSource && DataSource.map((user, index) =>
                                        <tr key={index} className={user.trantype === "Debit" ? 'thsmallcust' : "thsmallcustgreen"} >
                                          <td className={user.trantype === "Debit" ? 'thsmallcust' : "thsmallcustgreen"}>{formatDate(user.date)}</td>
                                          <td className={user.trantype === "Debit" ? 'thsmallcust' : "thsmallcustgreen"}>{user.grtype}</td>
                                          <td className={user.trantype === "Debit" ? 'thsmallcust' : "thsmallcustgreen"}>{user.rno}</td>
                                          <td className={user.trantype === "Debit" ? 'thsmallcust' : "thsmallcustgreen"}>{user.trantype}</td>
                                          <td className={user.trantype === "Debit" ? 'thsmallcust' : "thsmallcustgreen"}>{user.time && user.time !== "" ? user.time : "-"}</td>
                                          <td className={user.trantype === "Debit" ? 'thsmallcust' : "thsmallcustgreen"}>{user.type && user.type !== "" ? user.type : "-"}</td>
                                          <td className={user.trantype === "Debit" ? 'thsmallcust' : "thsmallcustgreen"}>{user.liter && user.liter !== "" ? parseFloat(user.liter) : 0}</td>
                                          <td className={user.trantype === "Debit" ? 'thsmallcust' : "thsmallcustgreen"}>{user.rate && user.rate !== "" ? parseFloat(user.rate) : 0}</td>
                                          <td className={user.trantype === "Debit" ? 'thsmallcust' : "thsmallcustgreen"}>{user.amt && user.amt !== "" ? parseFloat(user.amt) : 0}</td>

                                        </tr>
                                      )
                                    }
                                  </>
                                }
                              </tbody>
                              <tr style={{ backgroundColor: 'lightgray', fontWeight: 'bold' }}>
                                <td className='thsmallcust'>{t("common.total")}</td>
                                <td className='thsmallcustlarge'>-</td>
                                <td className='thsmallcust'>-</td>
                                <td className='thsmallcust'>-</td>
                                <td className='thsmallcust'>-</td>
                                <td className='thsmallcust'>-</td>
                                <td className='thsmallcust'>{DataSource.reduce((total, user) => total + parseFloat(user.liter), 0).toFixed(2)}</td>
                                <td className='thsmallcust'>-</td>
                                <td className='thsmallcust'>
                                  {parseFloat(
                                    DataSource.reduce((total, user) => {
                                      if (user.trantype === "Debit") {
                                        return total + parseFloat(user.amt);
                                      } else {
                                        return total - parseFloat(user.amt);
                                      }
                                    }, 0) + parseFloat(PreviousAmt)
                                  ).toFixed(2)}
                                </td>
                              </tr>
                            </table>
                          </>
                          :
                          <>
                            <table id="myTablebillyenebaki" className="table table-bordered">
                              <thead>
                                <tr>
                                  <th className='thsmallvikri' scope="col">{t("common.table.account_no")}</th>
                                  <th className='thsmallvikrimedium2' scope="col">{t("vikrireport.table.ratibName")}</th>
                                  <th className='thsmallvikri' scope="col">{t("vikrireport.table.buffaloLiter")}</th>
                                  <th className='thsmallvikri' scope="col">{t("vikrireport.table.cowLiter")}</th>
                                  <th className='thsmallvikri' scope="col">{t("vikrireport.table.totalLiter")}</th>
                                  <th className='thsmallvikri' scope="col">{t("vikrireport.table.totalReceivable")}</th>
                                </tr>
                              </thead>
                              <tbody>
                                {value.length > 0 ? tableFilter.map((user, index) =>
                                  <tr key={index}  >
                                    <td className='thsmallvikri'>{user.rno && user.rno !== "" ? user.rno : "-"}</td>
                                    <td className='thsmallvikrimedium2'>{user.rname && user.rname !== "" ? user.rname : "-"}</td>
                                    <td className='thsmallvikri'>{user.mhliter && user.mhliter !== "" ? parseFloat(user.mhliter).toFixed(2) : 0}</td>
                                    <td className='thsmallvikri'>{user.gayliter && user.gayliter !== "" ? parseFloat(user.gayliter).toFixed(2) : 0}</td>
                                    <td className='thsmallvikri'>{user.tliter && user.tliter !== "" ? parseFloat(user.tliter).toFixed(2) : "-"}</td>
                                    <td className='thsmallvikri'>{user.ryenebaki && user.ryenebaki !== "" ? parseFloat(user.ryenebaki).toFixed(2) : "-"}</td>
                                  </tr>
                                )
                                  :
                                  DataSource3 && DataSource3.map((user, index) =>
                                    <tr key={index}  >
                                      <td className='thsmallvikri'>{user.rno && user.rno !== "" ? user.rno : "-"}</td>
                                      <td className='thsmallvikrimedium2'>{user.rname && user.rname !== "" ? user.rname : "-"}</td>
                                      <td className='thsmallvikri'>{user.mhliter && user.mhliter !== "" ? parseFloat(user.mhliter).toFixed(2) : 0}</td>
                                      <td className='thsmallvikri'>{user.gayliter && user.gayliter !== "" ? parseFloat(user.gayliter).toFixed(2) : 0}</td>
                                      <td className='thsmallvikri'>{user.tliter && user.tliter !== "" ? parseFloat(user.tliter).toFixed(2) : "-"}</td>
                                      <td className='thsmallvikri'>{user.ryenebaki && user.ryenebaki !== "" ? parseFloat(user.ryenebaki).toFixed(2) : "-"}</td>

                                    </tr>
                                  )
                                }
                              </tbody>
                              <tr style={{ backgroundColor: 'lightgray', fontWeight: 'bold' }}>
                                <td className='thsmallcust'>{t("common.total")}</td>
                                <td className='thsmallcust'>-</td>
                                <td className='thsmallcust'>
                                  {value.length > 0
                                    ? tableFilter.reduce((total, user) => total + parseFloat(user.mhliter), 0).toFixed(2)
                                    : DataSource3.reduce((total, user) => total + parseFloat(user.mhliter), 0).toFixed(2)}
                                </td>
                                <td className='thsmallcust'>
                                  {value.length > 0
                                    ? tableFilter.reduce((total, user) => total + parseFloat(user.gayliter), 0).toFixed(2)
                                    : DataSource3.reduce((total, user) => total + parseFloat(user.gayliter), 0).toFixed(2)}
                                </td>
                                <td className='thsmallcust'>
                                  {value.length > 0
                                    ? tableFilter.reduce((total, user) => total + parseFloat(user.tliter), 0).toFixed(2)
                                    : DataSource3.reduce((total, user) => total + parseFloat(user.tliter), 0).toFixed(2)}
                                </td>
                                <td className='thsmallcust'>
                                  {value.length > 0
                                    ? tableFilter.reduce((total, user) => total + parseFloat(user.ryenebaki), 0).toFixed(2)
                                    : DataSource3.reduce((total, user) => total + parseFloat(user.ryenebaki), 0).toFixed(2)}
                                </td>
                              </tr>
                            </table>
                          </>
            }
          </div>
        </div>
      </div>
    </div>
  )
}

export default Vikrireport
